"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault"),
    _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react")),
    _classnames = _interopRequireDefault(require("classnames")),
    _Input = require("../../../common/styles/Input"),
    _locationSelectorResults = require("../styles/locationSelectorResults");

function buildAddressLabel(a) {
  var b = a.split(","),
      c = b[0],
      d = b.slice(1, b.length);
  return _react["default"].createElement(_react["default"].Fragment, null, _react["default"].createElement("span", null, c), _react["default"].createElement("span", {
    className: _locationSelectorResults.RESULT_ADDRESS
  }, d));
}

function LocationSelectorResult(a) {
  var b = a.suggestion,
      c = a.getResultProps;
  return _react["default"].createElement("div", c(b, {
    className: (0, _classnames["default"])((0, _Input.LIST_OPTION)(), _locationSelectorResults.RESULT, "location-selector__result")
  }), buildAddressLabel(b.description));
}

var _default = (0, _react.memo)(LocationSelectorResult);

exports["default"] = _default;